import { render } from "./ThemeToggleButton.vue?vue&type=template&id=165c37a2&ts=true"
import script from "./ThemeToggleButton.vue?vue&type=script&lang=ts"
export * from "./ThemeToggleButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__